interface DonutLegendItem {
  label: string
  value?: number
  dotClassName?: string
}

interface ChartEmptyStateProps {
  variant?: 'grid' | 'donut'
  heightClassName?: string
  gridRows?: number
  donutLegend?: DonutLegendItem[]
}

export function ChartEmptyState({
  variant = 'grid',
  heightClassName = 'h-[240px]',
  gridRows = 5,
  donutLegend = [],
}: ChartEmptyStateProps) {
  if (variant === 'donut') {
    return (
      <div className="flex w-full flex-col items-center justify-center gap-6 py-3">
        <div className="relative h-36 w-36 rounded-full border-[22px] border-gray-200">
          <div className="absolute inset-0 rounded-full border border-gray-100" />
        </div>

        {donutLegend.length > 0 && (
          <div className="grid w-full grid-cols-2 gap-x-3 gap-y-2 px-2 text-sm text-gray-800">
            {donutLegend.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-2 whitespace-nowrap"
              >
                <span
                  className={`inline-block h-3.5 w-3.5 shrink-0 rounded-full ${item.dotClassName ?? 'bg-gray-300'}`}
                />
                <span>{item.label}:</span>
                <span className="font-semibold">{item.value ?? 0}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={`relative w-full ${heightClassName}`}>
      <div className="relative flex h-full flex-col justify-between px-4 py-3">
        {Array.from({ length: gridRows }).map((_, index) => (
          <div
            key={`grid-row-${index}`}
            className="h-0 border-t-0 border-dashed border-gray-300/60"
          />
        ))}
      </div>
    </div>
  )
}
